module.exports = __webpack_public_path__ + "img/kebab.8f750ef2.png";